module.exports = function(input) {
  input = input instanceof Array ? input : input.toString().split('')

  return input
}
